import useGradesTableStore from '../../../store/useGradesTableStore';
import useClassroomLesson from '../../../hooks/queries/useClassroomLesson';
import useLessonNotebooks from '../../../hooks/queries/exerciseResults/useLessonNotebooks';
import useSectionNotebookExerciseResults
  from '../../../hooks/queries/exerciseResults/useSectionNotebookExerciseResults';
import useSectionNotebooksQuestionAnswers
  from '../../../hooks/queries/questionAnswers/useSectionNotebooksQuestionAnswers';
import isAwaitingData from '../../../hooks/queries/isAwaitingData';

// AIDEV-NOTE: classroomLesson is structural, so it is deliberately absent from isLoading — the
// table does not mount until it has resolved, and folding it in would skeleton every notebook cell
// again on any classroom-lesson refetch.
const useNotebookCellData = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const lesson = useGradesTableStore(state => state.lesson);

  const sectionResultsQuery = useSectionNotebookExerciseResults();
  const lessonResultsQuery = useLessonNotebooks();
  const progressQuery = useSectionNotebooksQuestionAnswers();
  const { data: classroomLesson } = useClassroomLesson(classroom.id, lesson?.id);

  return {
    classroomLesson,
    isLoading: isAwaitingData(sectionResultsQuery, lessonResultsQuery, progressQuery),
    lessonNotebookExerciseResults: lessonResultsQuery.data,
    sectionNotebookExerciseResults: sectionResultsQuery.data,
    sectionNotebooksProgress: progressQuery.data,
  };
};

export default useNotebookCellData;
